<template>
    <div id="page-container" class="sidebar-dark sidebar-mini sidebar-o enable-page-overlay side-scroll page-header-fixed main-content-boxed bg-sidebar-light page-footer-fixed">

        <slot name="sidebar-overlay"></slot>

        <slot name="sidebar"></slot>

        <slot name="header"></slot>

        <!-- Main Container -->
        <main id="main-container" class="container-fluid">
            <slot name="content"></slot>
        </main>
        <!-- END Main Container -->

        <slot name="footer"></slot>
        <!-- END Footer -->
    </div>

</template>

<script>
    // We will now register app components here

    export default {
        components: {}
    }
</script>
